import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'app-pm-constructions-list',
  templateUrl: './pm-constructions-list.component.html',
  styleUrls: ['./pm-constructions-list.component.scss']
})
export class PmConstructionsListComponent implements OnInit, AfterViewInit, OnChanges {
  displayedColumns: string[] = ['bmNr', 'category', 'project', 'status', 'constStatus', 'specStatus', 'ai', 'actions'];
  @Input() constructions: ProleisObject[];
  @Input() filter: string;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<ProleisObject> = new MatTableDataSource([]);

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'bmNr':
          return item.NAME;
        case 'category':
          return item.PARENT_MODULE;
        case 'project':
          return item.PROJECT;
        case 'status':
          return item.CHANGE_STATUS;
        case 'constStatus':
          return item.CONSTSTATUS;
        case 'specStatus':
          return item.STATUSSPEC;
        case 'ai':
          return item.INDEX_ZI;
        default:
          return item[property];
      }
    };
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.constructions) {
      // force new array reference and trigger update
      this.dataSource.data = Array.isArray(this.constructions) ? [...this.constructions] : [];
      this.cdr.detectChanges();
    }
    if (changes.filter) {
      this.dataSource.filter = this.filter || '';
    }
  }

  trackByFn(index: number, item: ProleisObject) {
    return item?.OBJECT_ID || index;
  }
}
